import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LinkedinIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M6.5,4.69A1.63,1.63,0,1,0,8.12,6.32,1.62,1.62,0,0,0,6.5,4.69Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "5.11",
    y: "9.13",
    width: "2.78",
    height: "10.19"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.74,9.13V19.31h2.78V14.12c0-2.88,3.7-3.11,3.7,0v5.19H19V13.05c0-4.86-5.19-4.68-6.48-2.29V9.13Z"
  })]
}), 'LinkedInIcon');